import { render, staticRenderFns } from "./DetailsModel.vue?vue&type=template&id=78b8c102"
import script from "./DetailsModel.vue?vue&type=script&lang=js"
export * from "./DetailsModel.vue?vue&type=script&lang=js"
import style0 from "./DetailsModel.vue?vue&type=style&index=0&id=78b8c102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports